import {api} from '@/http'

// 委派单列表
const getPGList = (data, callback, back) => {
  api('/api/PG_WP/List', 'post', data, callback, back)
}

// 类型下拉
const getPGTypeList = (callback, back) => {
  api('/api/Main/SelectList', 'post', {TypeName: 'project'}, callback, back)
}

// 委派单添加
const wpAdd = (data, callback, back) => {
  api('/api/PG_WP/Insert', 'post', data, callback, back)
}

// 委派单删除
const wpDel = (id, callback, back) => {
  api('/api/PG_WP/Delete', 'post', {Id: id}, callback, back)
}

// 委派单详情
const wpDetail = (id, callback, back) => {
  api('/api/PG_WP/Detail', 'post', {Id: id}, callback, back)
}

// 委派单流程
const wpFlow = (id, callback, back) => {
  api('/api/PG_WP/StageList', 'post', {Id: id}, callback, back)
}

// 委派单流程报告
const wpFlowBg = (id, callback, back) => {
  api('/api/PG_BG/StageDetail', 'post', {Id: id}, callback, back)
}

// 委派单流程报告上传后显示
const wpFlowBgShow = (data, callback, back) => {
  api('/api/PG_BG/Import', 'post', data, callback, back)
}

// 委派单流程保存
const wpFlowBgAdd = (data, callback, back) => {
  api('/api/PG_BG/Insert', 'post', data, callback, back)
}

// 委派单流程反馈
const wpFlowBgNoExamine = (data, callback, back) => {
  api('/api/PG_BG/NoExamine', 'post', data, callback, back)
}

// 委派单流程通过
const wpFlowBgExamine = (data, callback, back) => {
  api('/api/PG_BG/Examine', 'post', data, callback, back)
}

// 二手房委派单列表
const getESFList = (data, callback, back) => {
  api('/api/PG_WP/ERList', 'post', data, callback, back)
}

// 通知归档
const msgGD = (id, callback, back) => {
  api('/api/CQ_WP/SubmitGD', 'post', {Id: id}, callback, back)
}

// 通知公章
const msgGZ = (data, callback, back) => {
  api('/api/CQ_WP/SubmitGZ', 'post', data, callback, back)
}

// 项目收费--列表
const getPGChargeList = (data, callback, back) => {
  api('/api/Charge/List_PGWP', 'post', data, callback, back)
}

// 房屋询价
const getInquiryList = (data, callback, back) => {
  api('/api/XunJia/List', 'post', data, callback, back)
}

// 房屋询价--删除
const delInquiry = (id, callback, back) => {
  api('/api/XunJia/Delete', 'post', {Id: id}, callback, back)
}

// 房屋询价--详情
const descInquiry = (id, callback, back) => {
  api('/api/XunJia/Detail', 'post', {Id: id}, callback, back)
}

// 房屋询价--添加
const addInquiry = (data, callback, back) => {
  api('/api/XunJia/Insert', 'post', data, callback, back)
}

// 房屋询价--导入
const importInquiry = (data, callback, back) => {
  api('/api/XunJia/Import', 'post', data, callback, back)
}

// 评估提交判断
const submitPG = (data, callback, back) => {
  api('/api/PG_BG/ZCList', 'post', data, callback, back)
}

// 评估绩效设置详情
const JXPGSettingDesc = (callback, back) => {
  api('/api/JX_Setting/JXDefaultDetail', 'post', {}, callback, back)
}
// 评估绩效设置保存
const JXPGSettingSave = (data, callback, back) => {
  api('/api/JX_Setting/JXDefaultSave', 'post', data, callback, back)
}

// 绩效系数列表
const getPGJXList = (data, callback, back) => {
  api('/api/JX_PG/List_XS', 'post', data, callback, back)
}

// 绩效系数详情
const getPGJXDesc = (data, callback, back) => {
  api('/api/JX_PG/XSDetail', 'post', data, callback, back)
}

// 绩效系数保存
const getPGJXSave = (data, callback, back) => {
  api('/api/JX_PG/XSSave', 'post', data, callback, back)
}

// 绩效发放列表
const getPGJXIssueList = (data, callback, back) => {
  api('/api/JX_PG/List_Pay', 'post', data, callback, back)
}

// 绩效发放确认
const getPGJXIssueSaveEr = (data, callback, back) => {
  api('/api/JX_PG/PayErSave', 'post', data, callback, back)
}

// 绩效发放详情
const getPGJXIssueDesc = (data, callback, back) => {
  api('/api/JX_PG/PayDetail', 'post', data, callback, back)
}

// 绩效发放保存
const getPGJXIssueSave = (data, callback, back) => {
  api('/api/JX_PG/PaySave', 'post', data, callback, back)
}

// 绩效统计
const getPGJXTotalList = (data, callback, back) => {
  api('/api/JX_PG/JXTotalList', 'post', data, callback, back)
}

// 后期问题修改
const PGHqWp = (data, callback, back) => {
  api('/api/PG_WP/InsertHouQi', 'post', data, callback, back)
}

export default {
  getPGList,
  getPGTypeList,
  wpAdd,
  wpDel,
  wpDetail,
  wpFlow,
  wpFlowBg,
  wpFlowBgShow,
  wpFlowBgAdd,
  wpFlowBgNoExamine,
  wpFlowBgExamine,
  getESFList,
  msgGD,
  msgGZ,
  getPGChargeList,
  getInquiryList,
  delInquiry,
  descInquiry,
  addInquiry,
  importInquiry,
  submitPG,
  JXPGSettingDesc,
  JXPGSettingSave,
  getPGJXList,
  getPGJXDesc,
  getPGJXSave,
  getPGJXIssueList,
  getPGJXIssueSaveEr,
  getPGJXIssueDesc,
  getPGJXIssueSave,
  getPGJXTotalList,
  PGHqWp
}



// WEBPACK FOOTER //
// ./src/api/pg/index.js